import { render, staticRenderFns } from "./plan_notes.vue?vue&type=template&id=1c108fe5&scoped=true&"
import script from "./plan_notes.vue?vue&type=script&lang=js&"
export * from "./plan_notes.vue?vue&type=script&lang=js&"
import style0 from "./plan_notes.vue?vue&type=style&index=0&id=1c108fe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c108fe5",
  null
  
)

export default component.exports